import styled from '@emotion/styled';
import Link from 'next/link';
import { minDeviceWidth } from '../../styles/responsive';
import { ReactComponent as InsertPhotoSvg } from './icons/insert-photo.svg';
import { ReactComponent as KebabMenuSvg } from './icons/kebab.svg';

export const Container = styled.div<{ isLast: boolean }>`
  border-bottom: ${({ isLast, theme }) =>
    isLast ? '0px' : `1px solid ${theme.default.colors.n2}`};
  padding: 16px;

  @media ${minDeviceWidth('mobile-landscape')} {
    padding: 24px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column-reverse;
  align-items: flex-start;
  padding-bottom: 24px;

  @media ${minDeviceWidth('mobile-landscape')} {
    flex-direction: row;
    align-items: center;
  }
`;

export const Flows = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;

  @media ${minDeviceWidth('mobile-landscape')} {
    margin-top: 0px;
  }
`;

export const StyledLink = styled(Link)<{ isMoreItem?: boolean }>`
  cursor: pointer;
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.default.colors.n1};
  color: ${({ theme }) => theme.default.colors.n5};
  margin-right: 8px;
  border-radius: 4px;
  border: 0px;
  flex-shrink: 0;
  text-decoration: none;

  &:hover {
    background-color: ${({ theme }) => theme.default.colors.n2};
  }
  &:active {
    background-color: ${({ theme }) => theme.default.colors.n3};
  }
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  white-space: nowrap;

  ${({ isMoreItem = false }) =>
    isMoreItem &&
    `
    margin-right: 0;
    position: absolute;
    top: 48px;
    right: 0px;
  `}
`;

export const LineItem = styled.div`
  display: flex;
  margin-bottom: 16px;

  & img {
    border-radius: 2px;
  }
`;

export const ItemDetails = styled.div`
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ItemTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const ItemPriceAndQuantity = styled.div`
  display: flex;
  gap: 8px;
`;

export const ItemQuantity = styled.div`
  color: ${({ theme }) => theme.default.colors.n3};
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
`;

export const InitialItemQuantity = styled(ItemQuantity)`
  color: ${({ theme }) =>
    theme.default.colors.Feedback.Variations.Error.Error4};
  text-decoration: line-through;
`;

export const ToggleItemContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  cursor: pointer;

  & svg {
    width: 20px;
    height: 20px;
  }
`;

export const ToggleText = styled.div`
  font-size: 16px;
  line-height: 24px;
`;

export const StyledInsertPhotoSvg = styled(InsertPhotoSvg)`
  padding: 16px;
  box-sizing: content-box;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.default.colors.n1};
`;

export const MoreMenu = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const StyledKebabMenuSvg = styled(KebabMenuSvg)`
  padding: 8px;
  background-color: ${({ theme }) => theme.default.colors.n1};
  border-radius: 4px;
  cursor: pointer;
  box-sizing: content-box;

  &:hover {
    background-color: ${({ theme }) => theme.default.colors.n2};
  }
  &:active {
    background-color: ${({ theme }) => theme.default.colors.n3};
  }
`;
